export default __webpack_public_path__ + "static/media/vku_logo.59d79670.svg";